<div class="container">
  <div class="row">
    <div class="col-md-12 no-padding">
      <div class="dropdown">
        <div class="input-group" style="height: calc(2.25rem + 2px)">
          <input
            type="text"
            #inputItem
            (input)="pesquisarItem($event)"
            [value]="valueItem"
            class="form-control input_dropdown dados_internos"
            [placeholder]="dropDownConfig.placeholder"
            i18n-placeholder="@@nomeOperacao"
            [readOnly]="botaoSomenteLeitura"
            [id]="dropDownConfig.dropDownId"
          />
          <div>
            <button
              class="btn seta-dropdown-mesclada"
              [ngClass]="botaoSomenteLeitura ? 'btn-disabled' : 'btn-enabled'"
              type="button"
              id="dropdownButton_{{ dropDownConfig.idItem }}"
              (click)="mostrarLista()"
            >
              <i class="fa fa-angle-down"></i>
            </button>
          </div>
          <div
            [ngClass]="
              exibeLista ? 'dropdown-menu dropDown-scroll' : 'dropdown-menu'
            "
          >
            <div style="margin-left: 5px; margin-right: 5px">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">
                    <span class="fa fa-search"></span>
                  </span>
                </div>
                <input
                  type="text"
                  [value]="textoPesquisa"
                  class="form-control dropdown-menu-input-search"
                  style="font-size: 15px"
                  placeholder=" Pesquisar"
                  (input)="pesquisarItem($event)"
                  i18n-placeholder="@@pesquisarDropDown"
                />
              </div>
            </div>
            <div *ngFor="let item of listItem">
              <a
                class="dropdown-item dados_internos"
                target="_blank"
                id="{{ dropDownConfig.idItem }}_{{ item.Name }}"
                (click)="selecionarOpcao(item)"
                *ngIf="item.Exibe"
                >{{ item.Name }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
